import * as DeviceActions from './device.actions';
import { createReducer, on } from '@ngrx/store';
export const deviceFeatureKey = 'device';

export interface FlexLayoutMedia {
  isExtraSmall: boolean;
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
  isExtraLarge: boolean;

  isLessThanSmall: boolean;
  isLessThanMedium: boolean;
  isLessThanLarge: boolean;
  isLessThanExtraLarge: boolean;

  isGreaterThanExtraSmall: boolean;
  isGreaterThanSmall: boolean;
  isGreaterThanMedium: boolean;
  isGreaterThanLarge: boolean;

  isLandscape: boolean;
  isPortrait: boolean;
  isRetina2: boolean;
  isRetina3: boolean;
  isStandalone: boolean;
}

export interface DeviceState extends FlexLayoutMedia {
  deviceWidth: number;
  deviceHeight: number;

  isMobile: boolean;
  isDesktop: boolean;
}

export const initialDeviceState: DeviceState = {
  deviceWidth: undefined,
  deviceHeight: undefined,

  isMobile: false,
  isDesktop: false,

  isExtraSmall: false,
  isSmall: false,
  isMedium: false,
  isLarge: false,
  isExtraLarge: false,

  isLessThanSmall: false,
  isLessThanMedium: false,
  isLessThanLarge: false,
  isLessThanExtraLarge: false,

  isGreaterThanExtraSmall: false,
  isGreaterThanSmall: false,
  isGreaterThanMedium: false,
  isGreaterThanLarge: false,

  isLandscape: false,
  isPortrait: false,
  isRetina2: false,
  isRetina3: false,
  isStandalone: false,
};

export const reducer = createReducer(
  initialDeviceState,
  on(
    DeviceActions.setDeviceWidthHeight,
    (state, { deviceWidth, deviceHeight }) => ({
      ...state,
      deviceWidth,
      deviceHeight,
    })
  ),
  on(DeviceActions.setCurrentDevice, (state, { isMobile, isDesktop }) => ({
    ...state,
    isMobile,
    isDesktop,
  })),
  on(
    DeviceActions.flexLayoutMediaObserverEmitted,
    (state, { flexLayoutMedia }) => ({ ...state, ...flexLayoutMedia })
  )
);
